import { render, staticRenderFns } from "./itemcategory.vue?vue&type=template&id=4819db35"
import script from "./itemcategory.vue?vue&type=script&lang=js"
export * from "./itemcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports